import React from 'react';
import { MapPin } from 'lucide-react';

export const BottomToolbar = ({ userLocation, onCurrentLocationPOI, onMapClickPOI }) => {
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[300]">
      <div className="flex items-center gap-4 px-4 py-2 rounded-full">
        <button
          onClick={onCurrentLocationPOI}
          disabled={!userLocation}
          className={`p-2 rounded-full transition-colors ${
            !userLocation
              ? 'bg-gray-600 cursor-not-allowed opacity-50'
              : 'bg-green-600 hover:bg-green-700 text-white'
          }`}
          title={!userLocation ? 'Location not available' : 'Add POI at current location'}
        >
          <MapPin className="w-5 h-5" />
        </button>
        
        <div className="h-8 w-px bg-white/10" />
        
        <button
          onClick={onMapClickPOI}
          className="p-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white transition-colors"
          title="Add POI by clicking on map"
        >
          <MapPin className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};